import { validators } from '../../utils/validators';

const validate = values => {
    const { REQUIRED, EMAIL, MAX_LENGTH } = validators;
    const errors = {};
    if (REQUIRED(values.name)) {
        errors.name = 'Please enter Aggregator Name';
    }
    if (values.name) {
        errors.name = MAX_LENGTH(values.name, 50);
    }
    if (REQUIRED(values.email)) {
        errors.email = 'Please enter a email address';
    }
    if (EMAIL(values.email)) {
        errors.email = 'Please enter a valid email address';
    }
    if (EMAIL(values.communicationEmailId)) {
        errors.communicationEmailId =
            'Please enter a valid communication email address';
    }
    if (REQUIRED(values.relationshipManagerId)) {
        errors.relationshipManagerId =
            'Please enter a Relationship Manager Name';
    }
    if (
        values.portalAccess &&
        Array.isArray(values.portalAccess) &&
        values.portalAccess.includes('portalAccess')
    ) {
        if (REQUIRED(values.userEmail)) {
            errors.userEmail = 'Please enter a email address';
        }
        if (EMAIL(values.userEmail)) {
            errors.userEmail = 'Please enter a valid email address';
        }
    }
    return errors;
};

export default validate;
